module.exports = __webpack_public_path__ + "static/03-MARRUECOS-MAHIA.356854ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/beverages/03-MARRUECOS-MAHIA.png
// module id = 597
// module chunks = 35783957827783